import {
  NO_SIDEBAR_ROUTES,
  INVITED_USER_COLOR,
  WHATSAPP_ROUTE,
  CHAT_ROUTE,
  CHAT_CHANNEL,
  WHATSAPP_CHANNEL
} from '../constants/channelAdmin.const';
import { generalInformation } from '../../sharedmailbox/create/assets/constants/generalInformationConstants';
import { WIDGET_DEFAULT } from '../constants/chatWidget.const';
import { isFeatureEnabled } from 'h-commons';

const isNoSidebarRoute = () => ( NO_SIDEBAR_ROUTES.some(route => window.location.href.includes(route)) );

const getGeneralConstants = () => {
  if(location.pathname.includes(WHATSAPP_ROUTE)){
    return generalInformation.whatsapp;
  } else if(location.pathname.includes(CHAT_ROUTE)){
    return generalInformation.hiverChat;
  }
}

const getInitStateForChannel = () => {
  if(location.pathname.includes(WHATSAPP_ROUTE)){
    return {
      channel: WHATSAPP_CHANNEL,
      whatsapp_settings: {},
      name: '',
      users: []
    }
  } else if(location.pathname.includes(CHAT_ROUTE)){
    return {
      channel: CHAT_CHANNEL,
      chat_settings: {},
      name: '',
      users: [],
      //These below states are for the new chatbot in admin panel
      is_workflow_enabled: false,
      chatbot_name: '',
      is_form_used: false,
    }
  }
}

const isWhatsapp = (route = WHATSAPP_ROUTE) => {
  return location && location.pathname && location.pathname.includes(route);
}

const getUsersToAdd = (usersToAdd, users) => {
  const usersMap = {};
  users.forEach( user => usersMap[user.email] = user);
  let invitedUserCount = 0;
  if(!Object.keys(usersMap).length){
    return [];
  }
  let targetUsers = [];
  usersToAdd.forEach( user => {
    let invited = user.invited;
    if(invited){
      invitedUserCount+=1;
    }
    let alreadyInvited = user.isInvited;
    let targetUser = usersMap?.[user?.value];
    targetUsers.push({
      email: user.value,
      first_name: invited || alreadyInvited ? user.value.split('@')[0] : targetUser.firstname,
      last_name: invited ? '' : targetUser.lastname,
      user_id: invited && !alreadyInvited? null: targetUser.id,
      is_confirmed_on_hiver: Boolean(targetUser?.status.includes('joined'))
    })
  })
  return { usersToAdd: targetUsers , invitedUserCount };
};

const getChatWidgetPayload = (
  { channel, id },
  { widgetData, welcome_message, hasCsat }
) => ({
  channel,
  id,
  chat_settings: {
    widget: { ...widgetData },
    welcome_message: { 
      is_enabled: welcome_message.has_welcome_message,
      message: welcome_message.message,
    },
    is_enabled_csat_ratings: hasCsat,
  },
});

const getBotConfigPayload = ({botName, isDefaultIcon, activeIconData, customIconData}) => ({
  bot_name: botName?.trim?.(),
  is_default_icon: isDefaultIcon,
  default_icon_url: isDefaultIcon && activeIconData ? activeIconData : null,
  custom_icon_data: customIconData || null
})

const getKbInChatPayload = (
  { channel, id },
  { enabled, kbId, origin, pinned_articles, has_enabled_once }
) => ({
  channel,
  id,
  chat_settings: {
    knowledge_base: { 
      enabled: enabled,
      id: kbId,
      origin: origin,
      pinned_articles: pinned_articles,
      has_enabled_once: has_enabled_once,
    },
  },
});

const getBotEditPayload = (
  {channel, id},
  botConfiguration = {}
) => ({
  channel,
  id,
  chat_settings: {
    bot_configuration: getBotConfigPayload(botConfiguration)
  }
})

const trimEmptyLine = (strMultiline) => (
  strMultiline.replace(/(^[ \t]*\n)/gm, '')
);

const getTranscriptPayload = (
  { channel, id, name },
  { agentConfig, visitorConfig }
) => ({
  channel,
  id,
  name,
  chat_settings: {
    transcripts: {
      agent: agentConfig,
      visitor: visitorConfig,
    },
  },
  add_users: [],
  remove_users: [],
});

const getAddParticipantsPayload = (
  { channel, id, name },
  selectedUsers,
) => ({
  channel,
  id,
  name,
  add_users: parseSelectedUsers(selectedUsers),
  remove_users:[],
});

const parseSelectedUsers = (selectedUsers) => {
  return selectedUsers.map((user) => ({
    email: user.email,
    first_name: user.firstname
      ? user.firstname
      : user.email.substring(0, user.email.lastIndexOf('@')),
    last_name: user.lastname,
    user_id: user.id,
    is_confirmed_on_hiver: user.is_confirmed_on_hiver
  }));
};

/**
 * Checks if emailid is already present in
 * @param {String} email 
 * @param {Array} options 
 */
function checkIfUserIspresentInOption(email, options) {
    const matchedIndex = options.findIndex(user => user.email === email);
    return {
        isPresent: matchedIndex >= 0,
        userIndex: matchedIndex
    };
}

const sortByInsensitive = (list, key) => (
  list.sort((first, second) => (first[key] || '').toLowerCase() < (second[key] || '').toLowerCase() ? -1 : 1)
);

/**
 * Returns sample option for a given email id
 * @param {String} email 
 */
function getOptionForEmail(email) {
    const label = `Invited (${email})`;
    const firstname = email.substring(0, email.lastIndexOf('@'));
    const sampleOption = {
      avatarColor: null,
      avatar_url: null,
      email,
      fullName: label,
      id: null,
      isInvited: 1,
      label,
      type: 'user',
      value: email,
      firstname: firstname,
      lastname: '',
    };
    return sampleOption;
}

const parseParticipants = (participants) => {
  const parsedList = participants.map((user) => {
    if(!user.is_confirmed_on_hiver)
    {
      const name = `Invited <${user.email}>`;
      return {
        ...user,
        id: user.user_id,
        name: name,
        first_name: name,
        avatarColor: INVITED_USER_COLOR,
      };
    }
    else{
      return {
      ...user,
      id: user.user_id,
      }
    }
  });
  return sortByInsensitive(parsedList, 'first_name');
};

const getRemoveUserPayload = ({ channel, id, name }, selectedUsers) => ({
  channel,
  id,
  name,
  add_users: [],
  remove_users: selectedUsers,
});
const getSMName = (smName) => (typeof smName == 'string' ? sanitiseWhitespace(smName.toLowerCase()) : smName);

//trims whitespaces at the begining and ends of a string, also removes any extra whitespaces between words
const sanitiseWhitespace = (str) => (typeof str == 'string' ? str.trim().replace(/\s\s+/g, ' ') : str );

const getChatWidgetDefaultValues = (isEditMode, {
  is_enabled_csat_ratings,
  welcome_message,
  widget,
}) => {
  const widgetDefaultValues = {
    hasCsat: true,
    hasEmojiPicker: true,
    hasFilePicker: true,
    hasWelcomeMessage: false,
    heading: WIDGET_DEFAULT.HEADING,
    logo: {
        fileUploaded: true,
        logoUrl: '',
        data: '',
    },
    selectedColor: WIDGET_DEFAULT.SELECTED_COLOR,
    tagline: WIDGET_DEFAULT.TAGLINE,
    welcomeMessage: WIDGET_DEFAULT.WELCOME_MESSAGE,
  };

  if (isEditMode) {
    widgetDefaultValues.hasCsat = is_enabled_csat_ratings;
    widgetDefaultValues.hasEmojiPicker = widget?.is_display_emoji_picker;
    widgetDefaultValues.hasFilePicker = widget?.is_display_file_picker;
    widgetDefaultValues.hasWelcomeMessage = welcome_message?.is_enabled;
    if (welcome_message?.is_enabled) {
      widgetDefaultValues.welcomeMessage = welcome_message?.message;
    }
    widgetDefaultValues.heading = widget?.headline;
    widgetDefaultValues.logo.logoUrl = widget?.logo_url;
    widgetDefaultValues.selectedColor = widget?.color;
    widgetDefaultValues.tagline = widget?.tagline;
  }

  return widgetDefaultValues;
};

/**
 * Returns combined object having users which are not part of sm
 * @param {Array} smUsers of sm
 * @param {Array} allUsers of ug
 */
function getUsersWhoAreNotPartOfCi(smUsers, allUsers) {
    const finalUsers = {};
    for (let counter = 0; counter < allUsers.length; counter++) {
        const ugUser = allUsers[counter];
        if (parseInt(ugUser.blocked)) {
            continue;
        }
        let isPresent = false;
        for (let smUserCounter = 0; smUserCounter < smUsers.length; smUserCounter++) {
            const smUser = smUsers[smUserCounter];
            if (parseInt(smUser.blocked) && !(smUser.id in finalUsers)) {
                finalUsers[smUser.userid] = smUser;
            }
            if ((smUser.email === ugUser.email || ugUser.id in finalUsers) &&
                !isPresent) {
                isPresent = true;
            }
        }
        if (!isPresent) {
            finalUsers[ugUser.id] = ugUser;
        }
    }
    return Object.keys(finalUsers).map((key) => finalUsers[key]);
}

function userPresentInSelectedUsers(selectedUsers, userEmail) {
  return selectedUsers.findIndex((user) => user.email === userEmail);
}

/**
* Returns users which are invited in current flow and are not part of present ug
* @param {Array} selectedUsers 
* @param {Array} presentUsers 
 * @param {Number} number_of_users
*/
function getAddionalUsers (selectedUsers, presentUsers, number_of_users) {
  const allEmailIds = presentUsers.map((user) => user.email);
  const uncommonUsers = selectedUsers.filter(
    (user) => allEmailIds.indexOf(user.email) === -1
  );
  const totalAvailableNewsUsers = number_of_users - allEmailIds.length;
  if (totalAvailableNewsUsers < 0) {
    return {
      additionalUsers: uncommonUsers.length,
      hasExceeded: uncommonUsers.length + allEmailIds.length > number_of_users,
    };
  }
  const additionalUsers = uncommonUsers.length - totalAvailableNewsUsers;
  return {
    hasExceeded: uncommonUsers.length + allEmailIds.length > number_of_users,
    additionalUsers: additionalUsers > 0 ? additionalUsers : 0,
  };
}

// Create new item in multi email input
const createOption = (label) => ({
  label,
  value: label,
});

// parse EmailList To Value in multi email input
const parseEmailListToValue = (emailList) =>
  emailList.map((email) => createOption(email));

// parse Value To EmailList in multi email input
const parseValueToEmailList = (values) => values.map((item) => item.label);

// get sidebar links for create section with non clickable links to prevent navigation and resetting create the flow
const getCreateLinks = (routes) => {
  const url = window.location.href;
  routes.forEach( routeItem  => routeItem.disabled = !url.includes(routeItem.to) ? true : false)
  return routes;
}

const fallbackCopyTextToClipboard = (text, parentId) => {

  let parentElement = document.body;

  // Replacing the parent element when parentId is defined, to handle cases such as when the modal opens on the screen.
  if (parentId) {
    parentElement = document.getElementById(parentId);
  }
 
  var textArea = document.createElement("textarea");
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  parentElement.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  parentElement.removeChild(textArea);
}

const copyText = (copyText, parentId) => {
  navigator.clipboard
    .writeText(copyText)
    .then(() => {
      console.log("successfully copied");
    })
    .catch(() => {
      console.log("something went wrong while copying using navigator.clipboard function. Trying fallback copy");
      fallbackCopyTextToClipboard(copyText, parentId);
    });
}

const country2flag = (countryCode) => {
    return countryCode
        .toUpperCase()
        .split('')
        .map(char => String.fromCodePoint(char.charCodeAt(0) + 0x1F1A5))
        .join('');
};

const isChatAutoAssignmentFeatureEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, 'rls-chat-auto-assignment');
};

const isAvatarFeatureEnabled = (availableFeatures) => {
  return isFeatureEnabled(availableFeatures, 'ftr-chatbot-avatar');
}

const isChatNudgesFeatureEnabled = (availableFeatures) => isFeatureEnabled(availableFeatures, 'rls-chat-nudges');

const isChatbotsReleaseEnabled = (availableFeatures) => isFeatureEnabled(availableFeatures, 'rls-chatbot');

const isChatbotsfeatureEnabled = (availableFeatures) => isFeatureEnabled(availableFeatures, 'ftr-chatbot');

const isChatSuggestionsEnabled = (availableFeatures) => isFeatureEnabled(availableFeatures, 'ftr-chat-suggestions');

const isKbInclusionInChatFeatureEnabled = (availableFeatures) => isFeatureEnabled(availableFeatures, 'ftr-kb-inclusion-in-chat');

export {
  copyText,
  isAvatarFeatureEnabled,
  isChatbotsfeatureEnabled,
  isChatSuggestionsEnabled,
  isChatbotsReleaseEnabled,
  isNoSidebarRoute,
  getUsersToAdd,
  getChatWidgetDefaultValues,
  getChatWidgetPayload,
  getBotConfigPayload,
  getBotEditPayload,
  createOption,
  parseEmailListToValue,
  parseValueToEmailList,
  getTranscriptPayload,
  getUsersWhoAreNotPartOfCi,
  userPresentInSelectedUsers,
  getAddParticipantsPayload,
  checkIfUserIspresentInOption,
  getAddionalUsers,
  getOptionForEmail,
  parseParticipants,
  getRemoveUserPayload,
  getSMName,
  getCreateLinks,
  sanitiseWhitespace,
  trimEmptyLine,
  sortByInsensitive,
  getGeneralConstants,
  getInitStateForChannel,
  isWhatsapp,
  isChatAutoAssignmentFeatureEnabled,
  isChatNudgesFeatureEnabled,
  country2flag,
  isKbInclusionInChatFeatureEnabled,
  getKbInChatPayload,
};
